import { ImageProps } from 'next/image';

export const blurDataURL: ImageProps['blurDataURL'] =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mN8VA8AAkkBY8DEq9wAAAAASUVORK5CYII=';
